/* eslint-disable */
export default {
  unknown: 'Tuntematon',
  anonymous: 'Nimetön',
  activeCall: 'Käynnissä oleva puhelu',
} as const;

// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"anonymous"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"activeCall"@#@ @source: @#@"Active Call"@#@
